import { logger } from 'src/utils/logger';
import axios, { endpoints } from 'src/utils/axios';

import {
  login,
  logout,
  logoutAll,
  switchSession,
} from 'src/stores/user-session';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ tenantId, username, password }) => {
  try {
    const params = { tenantId, username, password };

    const res = await axios.post(endpoints.auth.requestAccessToken, params);

    // The backend now returns a sessionId along with the cookies
    const { sessionId, access } = res.data;

    if (sessionId) {
      // We need to switch to this session context immediately to fetch user details
      // mechanism: switchSession updates the store, which updates axios interceptor
      switchSession(sessionId);

      // Fetch user details for this new session to store in the sidebar list
      const userRes = await axios.get(endpoints.me.details, { headers: { Authorization: `Bearer ${access}` } });
      const user = userRes.data;

      // Persist the session metadata
      login(sessionId, user, access);
    } else {
      // Fallback for older backend or missing session ID (shouldn't happen with new code)
      logger.warn('No sessionId returned from login');
      // Just mark logged in without session ID (legacy mode)
      login(null, null);
    }

  } catch (error) {
    logger.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({ email, password, firstName, lastName }) => {
  const params = {
    email,
    password,
    firstName,
    lastName,
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const { accessToken } = res.data;

    // SignUp flow might need adjustment if it auto-logs in.
    // For now assuming it redirects to login or similar.

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    // sessionStorage.setItem(STORAGE_KEY, accessToken);
  } catch (error) {
    logger.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOutCurrent = async () => {
  try {
    await axios.post(endpoints.auth.logout);
    await logout();
  } catch (error) {
    logger.error('Error during sign out:', error);
    throw error;
  }
};

export const signOutAll = async () => {
  try {
    await axios.post(endpoints.auth.logoutAll);
    await logoutAll();
  } catch (error) {
    logger.error('Error during sign out all:', error);
    throw error;
  }
};
